import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import Button from 'flarum/common/components/Button';
import Group from 'flarum/common/models/Group';
import Discussion from 'flarum/common/models/Discussion';
import Link from 'flarum/common/components/Link';
export default class SubscriptionCard extends Component {
  actor = app?.session?.user;
  loading = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.subscription = this.attrs.subscription;
  }
  view() {
    if (this.subscription === null) {
      return this.empty();
    }
    const related = this.subscription.relatesTo();
    if (related instanceof Group) {
      return this.group(related);
    }
    if (related instanceof Discussion) {
      return this.discussion(related);
    }
    return null;
  }
  empty() {
    return m("div", {
      className: "SubscribeCard"
    }, m("span", {
      className: "icon"
    }, m(Icon, {
      name: "fas fa-ban"
    })), m("h2", {
      className: "group"
    }, app.translator.trans('floxum-payments.forum.subscription-card.none')), m("div", {
      className: "description"
    }), m("div", {
      className: "controls"
    }));
  }
  discussion(discussion) {
    return m("div", {
      className: "SubscribeCard"
    }, m("span", {
      className: "icon"
    }), m("h2", {
      className: "group"
    }, app.translator.trans('floxum-payments.forum.subscription-card.' + this.subscription.paymentType())), m(Link, {
      href: app.route.discussion(discussion),
      className: "description"
    }, "\"", discussion.title(), "\" (", this.subscriptionInfo(), ")"), m("div", {
      className: "controls"
    }, this.button()));
  }
  group(group) {
    return m("div", {
      className: "SubscribeCard",
      style: group.color() ? {
        backgroundColor: group.color()
      } : ''
    }, m("span", {
      className: "icon"
    }, m(Icon, {
      name: group.icon() || ''
    })), m("h2", {
      className: "group"
    }, app.translator.trans('floxum-payments.forum.subscription-card.' + this.subscription.paymentType())), m("div", {
      className: "description"
    }, group.namePlural(), " (", this.subscriptionInfo(), ")"), m("div", {
      className: "controls"
    }, this.button()));
  }
  subscriptionInfo() {
    return this.subscription.amount() + ' ' + this.subscription.interval();
  }
  button() {
    if (!this.subscription.cancellable()) return [];
    return Button.component({
      icon: 'fas fa-hourglass-end',
      className: 'Button',
      onclick: () => this.cancelSubscription(),
      disabled: this.loading
    }, app.translator.trans('floxum-payments.forum.subscription-card.cancel-control'));
  }
  cancelSubscription() {
    this.loading = true;
    app.request({
      url: app.forum.attribute('apiUrl') + '/floxum-subscriptions/' + this.subscription.id(),
      method: 'delete'
    }).then(response => {
      this.subscription = app.store.pushPayload(response);
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('floxum-payments', 'forum/Pages/SubscriptionCard', SubscriptionCard);